import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getChannel } from 'services/ChannelService'
import { QueryMetaType } from 'types/reactQuery'

export const useGetChannelQuery = (uuid: string, enabled = true) => {
  const meta: QueryMetaType = {
    errorAdditionalData: { uuid },
  }

  return useQuery({
    queryKey: reactQueryKeys.channel(uuid),
    queryFn: () => getChannel(uuid),
    enabled,
    meta,
  })
}
